import { BasicStore } from '@bridebook/web/app-basic/lib/types';
import { createSelector } from 'reselect';

export const getArticles = (state: BasicStore) => state.articles;

export const getArticlesSupport = createSelector(
  getArticles,
  ({ articlesMarketSupport }) => articlesMarketSupport,
);

export const getArticle = createSelector(getArticles, ({ article }) => article);
export const getRelatedArticles = createSelector(
  getArticles,
  ({ relatedArticles }) => relatedArticles,
);
export const getArticlesList = createSelector(getArticles, ({ list }) => list);
export const getIsArticlesListLoaded = createSelector(getArticles, ({ listLoaded }) => listLoaded);
